
import moment from 'moment';
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { getModule } from 'vuex-module-decorators';
import { BIconArrowClockwise, BIconReply } from 'bootstrap-vue';
import TicketsModule from '../../store/tickets.module';
import TicketThread from './TicketThread.vue';
import TicketActionBar from './TicketActionBar.vue';
import LiveAgentMessageNew from '../../components/ticketing/LiveAgentMessageNew.vue';
import { statusVariant, statusLabelKey } from './ticketStatus';

@Component({
  components: {
    TicketThread,
    TicketActionBar,
    LiveAgentMessageNew,
    BIconArrowClockwise,
    BIconReply,
  },
  computed: { ...mapGetters(['locale']) },
})
export default class TicketDetail extends Vue {
  @Prop({ default: null }) ticket!: any;
  @Prop({ default: () => [] }) departments!: any[];
  @Prop({ default: () => [] }) agents!: any[];
  @Ref('thread') readonly thread;

  locale!: string;
  showReply = false;
  refreshing = false;

  get store(): TicketsModule {
    return getModule(TicketsModule, this.$store);
  }

  get variant() {
    return statusVariant(this.ticket && this.ticket.status);
  }
  get labelKey() {
    return statusLabelKey(this.ticket && this.ticket.status);
  }
  get hasJobs() {
    return (
      this.ticket &&
      Array.isArray(this.ticket.jobs) &&
      this.ticket.jobs.length > 0
    );
  }
  get createdAt() {
    return this.ticket && this.ticket.createdAt
      ? moment(this.ticket.createdAt).locale(this.locale).format('L LT')
      : '';
  }
  get liveAgentUrl() {
    return `https://getitdone.ladesk.com/agent/index.php#Conversation;code=${
      this.ticket ? this.ticket.id : ''
    }`;
  }
  /**
   * Reload everything this pane shows: the ticket row — status and department
   * can be changed in LiveAgent behind our back — and the thread, which
   * re-syncs its messages from LiveAgent on read. reconcileTicket patches the
   * row in the store, which is the same object we render, so the header and the
   * action bar update in place.
   */
  async refresh() {
    if (!this.ticket || this.refreshing) return;
    this.refreshing = true;
    try {
      await Promise.all([
        this.store.reconcileTicket(this.ticket.id),
        this.thread ? this.thread.load() : Promise.resolve(),
      ]);
    } catch (e) {
      // The thread renders its own error state; a failed row reconcile just
      // leaves the header showing what we already had.
    } finally {
      this.refreshing = false;
    }
  }

  onMessageCreated() {
    this.showReply = false;
    if (this.thread) this.thread.load();
    this.$emit('updated');
  }
}
